import Marquee from "react-fast-marquee";

const words = [
  "Decodifica",
  "Riprogrammazione",
  "Azione",
  "PNL",
  "Focus",
  "Leadership",
  "Performance",
  "Sintesi",
];

export default function MarqueeSection() {
  return (
    <section
      className="relative border-y border-white/10 bg-background py-10 md:py-14 overflow-hidden"
      data-testid="marquee-section"
    >
      <Marquee speed={40} gradient={false} autoFill>
        {words.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="font-serif italic text-4xl md:text-6xl text-foreground/90 px-8 md:px-12">
              {w}
            </span>
            <span className="text-primary text-2xl md:text-4xl">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
